import { getGroupFolderPath } from "@/vybe-trader-client/symbols/stores/useSymbolsStore";
import type { Symbol } from "@/vybe-trader-client/symbols/types";

/**
 * Collects every symbol whose group folder is `folderPath` or a subfolder of it.
 *
 * Folder paths are derived with the store's `getGroupFolderPath`, so parsing is
 * consistent with the store's listings: separators may be `\` or `/`, flat
 * single-segment groups (e.g. "Majors") are real folders, and symbols with an
 * empty groupName live at the root. An empty `folderPath` (root) therefore
 * includes all symbols.
 */
export function collectSymbolsInFolder(
  symbols: Iterable<Symbol>,
  folderPath: readonly string[]
): Symbol[] {
  const allSymbols: Symbol[] = [];

  for (const symbol of symbols) {
    if (folderPath.length === 0) {
      // Root includes everything, including empty-groupName symbols.
      allSymbols.push(symbol);
      continue;
    }

    const symbolFolderParts = getGroupFolderPath(symbol);
    if (symbolFolderParts.length < folderPath.length) continue;

    const isInFolder = folderPath.every(
      (segment, index) => symbolFolderParts[index] === segment
    );
    if (isInFolder) {
      allSymbols.push(symbol);
    }
  }

  return allSymbols;
}
